import { useErrorHandler } from "@@common";
import React, { PropsWithChildren, useEffect, useState } from "react";
import Spinner from "../common/components/Spinner";
import ConfigContext, { Config } from "./ConfigContext";

declare global {
  interface Window {
    __CONFIG__?: Config;
  }
}

export const ConfigContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [config, setConfig] = useState<Config>();
  const [isPending, setIsPending] = useState(false);
  const errorHandler = useErrorHandler();

  useEffect(() => {
    // First check if config is available on the window object (injected at build time)
    const config = window.__CONFIG__;
    if (config) {
      setConfig(config);
      console.info("Config loaded config", config);
      return;
    }

    // Fallback: fetch from /config.json
    async function loadConfig() {
      setIsPending(true);
      try {
        const r = await fetch("/config.json");
        const c = (await r.json()) as Config;
        //throw new Error("Test error handling in ConfigContextProvider"); // Simulate error for testing
        //await delay(2000); // Simulate delay for testing purposes, remove later
        setConfig(c);
        console.info("Config loaded config", c);
      } catch (error) {
        await errorHandler(error);
      } finally {
        setIsPending(false);
      }
    }
    loadConfig();
  }, [errorHandler]);

  if (isPending || config === undefined) {
    return <Spinner />;
  }
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export default ConfigContextProvider;
